import React from 'react';
import styled from 'styled-components';
import { trackEvent } from '../facebookPixel';

const Simulator = () => {
  const handleSimulatorClick = () => {
    trackEvent('Contact', { content_name: 'Botão Saiba Mais Simulador' });
    console.log('Evento de botão simulador');
  };

  return (
    <SimulatorContainer>
      <ContentWrapper>
        <CallToAction>
          <Eyebrow>Simulador solar</Eyebrow>
          <CallToActionTitle>Descubra sua economia em poucos passos</CallToActionTitle>
          <CallToActionText>
            Calcule uma estimativa personalizada de economia e entenda como a energia solar pode reduzir sua
            conta de luz. Em poucos cliques você recebe uma prévia completa.
          </CallToActionText>
          <BenefitsList>
            <BenefitItem>Simulação rápida e gratuita</BenefitItem>
            <BenefitItem>Estimativa baseada no seu consumo</BenefitItem>
            <BenefitItem>Atendimento com especialistas GF</BenefitItem>
          </BenefitsList>
          <CallToActionButton
            href="https://azume.com.br/institucional/iframesrchttpsazumecombrsimulador645bd52a770a4b0014f497a7width100height600iframe"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleSimulatorClick}
          >
            Fazer simulação agora
          </CallToActionButton>
        </CallToAction>

        <ImageCard>
          <img src={require('../assets/image2.png')} alt="Simulador de economia em energia solar" />
        </ImageCard>
      </ContentWrapper>
    </SimulatorContainer>
  );
};

export default Simulator;

// Styled Components

const SimulatorContainer = styled.div`
  padding: 48px 24px 80px;
  background: radial-gradient(circle at top, rgba(255, 69, 0, 0.12), transparent 55%),
    ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  text-align: center;

  @media (min-width: 900px) {
    padding: 80px 32px 120px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  padding: 0;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;

  @media (min-width: 900px) {
    flex-direction: row;
    align-items: stretch;
    gap: 48px;
  }
`;

const ImageCard = styled.div`
  flex: 1;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 24px;
  padding: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.1);
  img {
    width: 100%;
    height: auto;
    border-radius: 18px;
    object-fit: cover;
    display: block;
  }
`;

const CallToAction = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
`;

const Eyebrow = styled.span`
  display: inline-flex;
  width: fit-content;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(255, 69, 0, 0.18);
  color: ${({ theme }) => theme.colors.primary};
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
  margin-bottom: 12px;
`;

const CallToActionTitle = styled.h2`
  font-size: clamp(2rem, 4vw, 2.8rem);
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.primary};
`;

const CallToActionText = styled.p`
  font-size: 1.05rem;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.colors.secondaryText};
  line-height: 1.6;
`;

const BenefitsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 24px;
  display: grid;
  gap: 10px;
`;

const BenefitItem = styled.li`
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.secondaryText};
  padding-left: 20px;
  position: relative;

  &:before {
    content: '●';
    position: absolute;
    left: 0;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const CallToActionButton = styled.a`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.text};
  padding: 12px 26px;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  border-radius: 999px;
  text-decoration: none;
  font-weight: 600;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(255, 199, 0, 0.3);
  }
`;
